<template>
    <form class="form-control-line m-t-40" @submit.prevent="onSubmit">
        <div class="card text-white bg-danger" v-if="errors">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <div class="form-group">
            <label for="mx">MX server<br>
                <i>
                    <b>example: </b>
                </i>
                <span>alt3.gmail-smtp-in.l.google.com</span>
            </label>
            <input type="text" name="mx" id="mx" v-model.trim="mx" class="form-control form-control-line">
            <div v-if="$v.mx.$error">
                <div class="text-danger" v-if="!$v.mx.required">MX server is required.</div>
            </div>
        </div>
        <div class="form-actions">
            <button type="submit" class="btn btn-info btn-rounded text-uppercase waves-effect waves-light m-r-5"
                    v-show="!loadingStatus">
                Save
            </button>
            <button class="btn btn-success btn-rounded text-uppercase waves-effect waves-light m-r-5" type="button"
                    disabled v-show="loadingStatus">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
            </button>
            <router-link to="/spam-mxs" class="btn btn-success btn-rounded text-uppercase waves-effect waves-light">
                Back
            </router-link>
        </div>
    </form>
</template>

<script>
    import { required } from 'vuelidate/src/validators';
    import SpamMxService from '../../services/SpamMxService';

    export default {
        name: 'SpamMxForm',
        data() {
            return {
                mx: '',
                loadingStatus: false,
                errors: ''
            }
        },
        validations: {
            mx: {required},
        },
        mounted() {
               this.$emit('hidePreloader', true);
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.loadingStatus = true;

                SpamMxService.addSpamMx(this.mx).then(response => {
                    if (response.data.error !== undefined) {
                        this.errors = response.data.error;
                    } else {
                                this.$snotify.success('Spam trap MX record ' + response.data.recordId + ' added successfully!', 'Success!!!');
                                this.$router.push({name: 'spamMxs'});
                    }
                    this.loadingStatus = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>